import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { CROSS_PLATFORM_SIDEBAR_COLLABORATOR_TRANSLATION_KEY } from "../constants";
export var en = /*#__PURE__*/_defineProperty({}, CROSS_PLATFORM_SIDEBAR_COLLABORATOR_TRANSLATION_KEY, {
  MODULE_HOME: 'Home',
  MODULE_RECOGNITION: 'Recognition',
  MODULE_PERFORMANCE: 'Performance',
  MODULE_CLIMATE: 'Climate',
  MODULE_LEARNING: 'E-Learning',
  MODULE_COMPANY: 'Company',
  MODULE_ANALYTICS: 'Analytics',
  MODULE_MY_RESULTS: 'My Results',
  TOOLTIP_CLIMATE_DESCRIPTION: "Measure your team's culture and satisfaction.",
  TOOLTIP_PERFORMANCE_DESCRIPTION: 'Evaluate performance through goals and competencies.',
  TOOLTIP_LEARNING_DESCRIPTION: "Manage learning strategies and enhance your team's skills.",
  TOOLTIP_RECOGNITION_DESCRIPTION: 'Manage badges awarded by collaborators.',
  TOOLTIP_COMPANY_DESCRIPTION: 'Monitor your processes and generate reports.',
  TOOLTIP_ANALYTICS_DESCRIPTION: 'Access the results of the processes you participate in.',
  TOOLTIP_MY_RESULTS_TITLE: 'Results',
  TOOLTIP_MY_RESULTS_DESCRIPTION: 'Analyze your results and those of the team you lead.',
  SUBMODULE_RESULTS_TITLE: 'My Results',
  SUBMODULE_TOOLTIP_MY_RESULTS_DESCRIPTION: 'Access the results of the processes you participate in',
  SUBMODULE_LEADER_RESULTS_TITLE: 'My Team',
  SUBMODULE_TOOLTIP_LEADER_RESULTS_DESCRIPTION: "Monitor your team's results",
  SUBMODULE_DIRECTORY_TITLE: 'Directory',
  SUBMODULE_TOOLTIP_DIRECTORY_DESCRIPTION: 'Information about company members',
  SUBMODULE_COMPANY_CHART_TITLE: 'Company Chart',
  SUBMODULE_COMPANY_CHART_DESCRIPTION: "Get to know the company's structure",
  SUBMODULE_RECOGNITION_TITLE: 'Badges',
  SUBMODULE_TOOLTIP_RECOGNITION_DESCRIPTION: 'Send badges to your colleagues and see the ones you received',
  SUBMODULE_RECOGNITION_REDEMPTION_TITLE: 'Rewards',
  SUBMODULE_TOOLTIP_RECOGNITION_REDEMPTION_DESCRIPTION: 'Redeem the points you earned for your achievements',
  SUBMODULE_OKRS_PERFORMNACE_TITLE: 'OKRs',
  SUBMODULE_TOOLTIP_OKRS_PERFORMANCE_DESCRIPTION: 'Visualize the progress of the business strategy and recognize the effort to achieve the objectives',
  SUBMODULE_GOALS_TITLE: 'Goals',
  SUBMODULE_TOOLTIP_GOALS_DESCRIPTION: 'Plan and set your work commitments',
  SUBMODULE_COMPETENCES_TITLE: 'Evaluations',
  SUBMODULE_TOOTLTIP_COMPETENCES_DESCRIPTION: 'Access the questionnaires of the assigned processes',
  SUBMODULE_FEEDBACK_TITLE: 'Feedback',
  SUBMODULE_TOOLTIP_FEEDBACK_DESCRIPTION: "Measure your company's feedback processes.",
  SUBMODULE_PID_TITLE: 'Individual Development Plan',
  SUBMODULE_TOOLTIP_PID_DESCRIPTION: 'Create processes to close gaps and promote growth.',
  SUBMODULE_SUCESSION_PLAN_TITLE: 'Succession Plan',
  SUBMODULE_TOOLTIP_SUCESSION_PLAN_DESCRIPTION: 'Create action plans for future vacancies.',
  SUBMODULE_CLIMATE_EVALUATION_TITLE: 'Climate Evaluations',
  SUBMODULE_TOOLTIP_CLIMATE_EVALUATION_DESCRIPTION: 'Access the questionnaire to mediate organizational climate',
  SUBMODULE_SURVEY_TITLE: 'Surveys',
  SUBMODULE_TOOLTIP_SURVEY_DESCRIPTION: 'Help your company collect information quickly and easily',
  // Learning links
  LEARNING_LINK_LEARND_AND_PROGRESS: 'LEARNING AND PROGRESS',
  LEARNING_LINK_MORE_FOR_YOU: 'More content',
  LEARNING_LINK_ENROLLED_COURSES: 'Courses',
  LEARNING_LINK_TOOLTIP_MORE_FOR_YOU_DESCRIPTION: 'Discover new learning content',
  LEARNING_LINK_PATHS: 'Learning paths',
  LEARNING_LINK_LIVE_SESSIONS: 'Live sessions',
  LEARNING_LINK_NOTES: 'Notes',
  LEARNING_LINK_STUDY_PLAN: 'Study plan',
  LEARNING_LINK_TOOLTIP_STUDY_PLAN: 'Plan your learning goal',
  LEARNING_LINK_MENTORSHIP: 'Mentorship',
  LEARNING_LINK_TOOLTIP_MENTORSHIP: 'Request advice from specialists',
  LEARNING_LINK_BLOG: 'Blog',
  LEARNING_LINK_LIVES: 'Lives',
  LEARNING_LINK_TOOLS: 'Tools',
  LEARNING_LINK_EVALUATIONS_AND_GOALS: 'EVALUATION AND ACHIEVEMENTS',
  LEARNING_LINK_SKILL_XP: 'Skill XP',
  LEARNING_LINK_PROJECTS: 'Projects',
  LEARNING_LINK_TOOLTIP_PROJECTS_DESCRIPTION: 'Carry out the projects of your courses',
  LEARNING_LINK_DIPLOMA: 'Diplomas',
  LEARNING_LINK_TOOLTIP_DIPLOMA_DESCRIPTION: 'Check the diplomas obtained for completing your learning',
  LEARNING_LINK_PENDING_TESTS: 'Pending tests',
  LEARNING_LINK_DONE_TESTS: 'Completed tests',
  LEARNING_LINK_ACCHIEVEMENTS: 'Achievements',
  LEARNING_LINK_REWARDS: 'Rewards',
  LEARNING_LINK_SKILL_XP_EVOLUTION: 'Skill XP Evolution',
  LEARNING_LINK_TOOLTIP_SKILL_XP_EVOLUTION_DESCRIPTION: 'Take tests and identify the level of your skills',
  LEARNING_LINK_GAMIFICATION: 'Gamification',
  LEARNING_LINK_TOOLTIP_GAMIFICATION_DESCRIPTION: 'Earn rewards for your learning achievements',
  LEARNING_LINK_MY_COURSES: 'My courses',
  LEARNING_LINK_TOOLTIP_MY_COURSES_DESCRIPTION: 'Access courses and paths you are enrolled in',
  LEARNING_LINK_RESOURCES: 'Resources',
  LEARNING_LINK_TOOLTIP_RESOURCES_DESCRIPTION: 'Learning resources',
  LEARNING_LINK_COURSES: 'Courses',
  LEARNING_LINK_DISCOVER: 'Discover',
  LEARNING_LINK_KNOWLEDGE_HUB: 'Catalog',
  // Misc
  SIDEBAR_BACK: 'Back',
  SIDEBAR_BACK_TO_PRODUCTS: 'Back to my products',
  SIDEBAR_EXPAND: 'Expand menu',
  SIDEBAR_COLLAPSE: 'Collapse menu',
  SIDEBAR_HELP: 'Help',
  SIDEBAR_HELP_DESCRIPTION: 'Access resources and support channel.',
  MODULE_PRODUCTS_SUBTITLE: 'PRODUCTS',
  // Admin data
  MODULE_HANA: 'Hana AI',
  MODULE_ADMIN: 'Admin',
  MODULE_STATISTICS: 'Statistics',
  MODULE_REPORTS: 'Reports',
  MODULE_ANALYTICS_TOOLTIP_DESCRIPTION: 'Monitor your processes and generate reports.',
  MODULE_HANA_TOOLTIP_DESCRIPTION: "Analyze your company's data with Artificial Intelligence.",
  MODULE_RECOGNITION_TOOLTIP_DESCRIPTION: 'Manage the badges awarded by the collaborators.',
  MODULE_PERFORMANCE_TOOLTIP_DESCRIPTION: 'Evaluate performance through goals and competencies.',
  MODULE_CLIMATE_TOOLTIP_DESCRIPTION: 'Measure the culture and satisfaction of your team.',
  MODULE_LEARNING_TOOLTIP_DESCRIPTION: "Manage learning strategies and enhance your team's skills.",
  MODULE_COMPANY_USERS: 'Users',
  MODULE_COMPANY_EXTRA_FIELDS: 'Personalized attributes',
  MODULE_COMPANY_DEPARTMENTS: 'Departments',
  MODULE_COMPANY_JOBS: 'Jobs',
  MODULE_COMPANY_ORGCHART: 'Organization chart',
  MODULE_ADMIN_TOOLTIP_DESCRIPTION: 'Manage your users and company settings.',
  MODULE_COMPANY_TOOLTIP_DESCRIPTION: 'Create users and manage the organizational structure.',
  MODULE_ACCOUNT: 'Account',
  MODULE_ACCOUNT_TOOLTIP_DESCRIPTION: 'Manage account data and check license consumption.',
  MODULE_LOGS: 'Logs',
  MODULE_LOGS_TOOLTIP_DESCRIPTION: 'History of actions carried out in the account.',
  MODULE_APPEREANCE: 'Appearance',
  MODULE_APPEREANCE_TOOLTIP_DESCRIPTION: 'Customize the panel with the organizational identity.',
  MODULE_COMMUNICATION: 'Communication',
  MODULE_COMMUNICATION_TOOLTIP_DESCRIPTION: 'Customize notifications for your users.',
  MODULE_AUTOMATIZATIONS: 'Automations',
  MODULE_AUTOMATIZATIONS_TOOLTIP_DESCRIPTION: 'Create automation rules to streamline tasks.',
  // learning links
  LEARNING_LINK_CONTENT: 'Content',
  LEARNING_LINK_CONTENT_TOOLTIP_DESCRIPTION: 'Manage courses, learning paths, and other resources.',
  LEARNING_LINK_SKILL_XP_EVOLUTION_TOOLTIP_DESCRIPTION: 'Measure the skills of each person.',
  LEARNING_LINK_GAMIFICATION_TOOLTIP_DESCRIPTION: 'Create, manage, and reward learning achievements.',
  LEARNING_LINK_PROGRESS: 'Progress',
  LEARNING_LINK_ANALYTICS_TOOLTIP_DESCRIPTION: 'Monitor your processes and generate reports.',
  LEARNING_LINK_SHOP: 'Shop',
  LEARNING_LINK_SHOP_TOOLTIP_DESCRIPTION: 'Customize your virtual content store.',
  LEARNING_LINK_INTEGRATIONS: 'Integrations',
  LEARNING_LINK_INTEGRATIONS_TOOLTIP_DESCRIPTION: 'Connect the platform with other systems.',
  // submodules
  SUBMODULE_RESULTS: 'Results',
  SUBMODULE_RESULTS_TOOLTIP_DESCRIPTION: 'Check the results of the processes you participate in.',
  SUBMODULE_MY_TEAM: 'My Team',
  SUBMODULE_MY_TEAM_TOOLTIP_DESCRIPTION: 'Monitor the results of your team.',
  SUBMODULE_ADMIN_RESULTS: 'Results',
  SUBMODULE_ADMIN_RESULTS_TOOLTIP_DESCRIPTION: 'Monitor the ranking of medals obtained by your collaborators.',
  SUBMODULE_MEDALS_REQUETS: 'Medal Requests',
  SUBMODULE_MEDALS_REQUETS_TOOLTIP_DESCRIPTION: 'Approve or reject the medals sent by the collaborators.',
  SUBMODULE_REWARDS: 'Rewards',
  SUBMODULE_REWARDS_TOOLTIP_DESCRIPTION: 'Manage and deliver redeemed rewards.',
  SUBMODULE_CONFIGURATION: 'Configuration',
  SUBMODULE_CONFIGURATION_TOOLTIP_DESCRIPTION: 'Create medals, define rules and messages.',
  SUBMODULE_RESULTS_PERFORMANCE: 'Results',
  SUBMODULE_RESULTS_PERFORMANCE_TOOLTIP_DESCRIPTION: 'Measure performance and team commitment.',
  SUBMODULE_COMPETENCES: 'Competencies',
  SUBMODULE_COMPETENCES_TOOLTIP_DESCRIPTION: 'Create and assign competency assessments.',
  SUBMODULE_GOALS: 'Goals',
  SUBMODULE_GOALS_TOOLTIP_DESCRIPTION: 'Plan and set your work commitments.',
  SUBMODULE_OKRS: 'OKRs',
  SUBMODULE_OKRS_TOOLTIP_DESCRIPTION: 'Visualize the progress of the business strategy and recognize the effort to achieve the objectives.',
  SUBMODULE_FEEDBACK: 'Feedback',
  SUBMODULE_FEEDBACK_TOOLTIP_DESCRIPTION: 'Measure the feedback processes in your company.',
  SUBMODULE_PID: 'Individual Development Plan',
  SUBMODULE_PID_TOOLTIP_DESCRIPTION: 'Create processes to close gaps and promote growth.',
  SUBMODULE_SUCCESSION_PLAN: 'Succession Plan',
  SUBMODULE_SUCCESSION_PLAN_TOOLTIP_DESCRIPTION: 'Create action plans for future vacancies.',
  SUBMODULE_LINK_GOALS: 'Goals',
  SUBMODULE_LINK_ALIGNMENT: 'Alignment',
  SUBMODULE_LINK_CONFIGURATION: 'Configuration',
  SUBMODULE_CLIMATE_EVALUATION: 'Climate Evaluations',
  SUBMODULE_CLIMATE_EVALUATION_TOOLTIP_DESCRIPTION: 'Access the questionnaire to measure the organizational climate.',
  SUBMODULE_SHORT_SURVEY: 'Short Surveys',
  SUBMODULE_SHORT_SURVEY_TOOLTIP_DESCRIPTION: 'Collect information quickly and easily.',
  SUBMODULE_OTHER_EVALUATIONS: 'Other Evaluations',
  SUBMODULE_OTHER_EVALUATIONS_TOOLTIP_DESCRIPTION: 'Additional evaluations such as psychosocial risks.',
  SUBMODULE_CONFIGURATION_MEDALS: 'Medals',
  SUBMODULE_CONFIGURATION_MESSAGES: 'Messages',
  SUBMODULE_CONFIGURATION_RULES_AND_PERMISSIONS: 'Rules and Permissions',
  SUBMODULE_TALENT: 'Talent',
  SUBMODULE_LEARNING: 'E-Learning',
  SUBMODULE_NBOX: 'N-Box',
  SUBMODULE_NBOX_TOOLTIP_DESCRIPTION: 'Create matrix crossing variables to visualize data.'
});